module.exports = __webpack_public_path__ + "img/help-desk.5c3c8ef2.png";